module.exports = __webpack_public_path__ + "static/img/welfare2.268bbd0d.jpg";